<template>
  <div id="RejectionBlock">
    <div>
      <h2>Уважаемый клиент!</h2>
      <p v-if="!loanInstReject || !loanPDLReject">К сожалению, компания отказала Вам в выдаче займа,<br> повторное обращение возможно через 1 месяц.</p>
      <div v-else id="rejectRedirectBlock">
        <p>К сожалению, мы не можем одобрить Вашу заявку. Ваша анкета не соответствовала строгим критериям, которые мы используем при проверке личных данных. Вашу заявку можно рассмотреть повторно через месяц.
        </p>
        <p>Вы можете претендовать на получение займа в другой компании. </p>
        <button v-on:click="redirectClient">Отправить заявку</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "formScreenFullFail",
  props: {
    loanInstReject: {
      type: Boolean,
      default: false
    },
    loanPDLReject: {
      type: Boolean,
      default: false
    },
  },
  methods:{
    redirectClient(){
      const link = 'https://microfinanceexpert.ru';
      this.$palantir.trackAction(128,link);
      setTimeout(()=>{
        //без таймера, не регистрируется клик, почему без таймера в базовом лендинге работает хз.
        document.location.href = link;
      },300);

    }
  },
  mounted() {
    this.$palantir.trackAction(180,JSON.stringify({
      loanInstReject: this.loanInstReject,
      loanPDLReject: this.loanPDLReject
    }));
  }
}
</script>

<style scoped>
h2 {padding: 10vw 0;color: #0D5740;}
p {margin-bottom: 9.12vw;color: #090A09}
a {text-decoration-line: underline}
button {width: 58.82vw;border-radius: 10px;}
#RejectionBlock {display: flex;flex-direction: column;align-items: center;}
#RejectionBlock > div {padding: 0;margin-bottom: 8.24vw;display: flex;flex-direction: column;align-items: center}
#RejectionBlock > div > div {display: flex;align-items: center}
#RejectionBlock > div > div > p:last-child {background: #4AAF3D;color: #FFFFFF;padding: 0.88vw 1.76vw;font-family: 'Lato-Bold';border-radius: 10px;margin-left: 0.88vw}
#rejectRedirectBlock{display: flex;align-items: center;justify-content: center;flex-direction: column}
@media (min-width: 760px) {
  h2 {padding: 3.47vw 0}
  p {margin-bottom: 3.23vw;text-align: center}
  button {width: 16.13vw}
  #RejectionBlock {padding-top: 7.6vw}
  #RejectionBlock > div {padding: 0 4.35vw 2.42vw;border-radius: 10px;box-shadow: 0 0.5vw 0.5vw rgba(0, 0, 0, 0.25);margin-bottom: 5.81vw;display: flex;flex-direction: column;align-items: center;background: #FFFBFB;}
  #RejectionBlock > div > div > p {margin-bottom: 3.23vw}
  #RejectionBlock > div > div > p:last-child {padding: 0.24vw 0.48vw;margin-left: 0.88vw;}
}

@media (min-width: 1240px) {
  h2 {padding: 41px 0 47px 0}
  p {margin-bottom: 40px}
  #RejectionBlock {padding-top: 97px}
  button {width: 200px}
  #RejectionBlock > div {padding: 0 54px 10px 54px;margin-bottom: 78px;box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25)}
}
</style>
